export default "__VITE_ASSET__DmXj3EtX__"